export const GENERATIVE_PLATFORM_LIBRARY_STALE_MS = 60_000;

export const COLLECTION_BUILD_SESSIONS_LIST_LIMIT = 40;

export const collectionBuildSessionsListQueryKey = (
  userId: string,
  limit = COLLECTION_BUILD_SESSIONS_LIST_LIMIT
) => ["collectionBuild", "sessions", "list", userId, limit] as const;

export const IMAGE_GENERATOR_LIBRARY_LIST_LIMIT = 80;

export const imageGeneratorLibraryQueryKey = (
  limit = IMAGE_GENERATOR_LIBRARY_LIST_LIMIT,
  offset = 0
) => ["imageGenerator", "library", limit, offset] as const;
